import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, act } from "react";
import "../Tower/Tower.css"

const Tower = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const towerNumber = location.state?.towerNumber;

    const [toggleButton, setToggleButton] = useState(1);

    const [list, setList] = useState([])

    const [auth, setAuth] = useState(false);
    const [password, setPassword] = useState("");

    const [indexes, setIndexes] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])
    const [randomized, setRandomized] = useState([])
    const [winList, setWinList] = useState([])

    const [activity, setActivity] = useState("")

    const one_list = ["EL", "Mi", "Sh", "Da", "Tk"]
    const two_list = ["MA", "We", "OC", "Sc", "Sc+We"]
    const three_list = ["MA", "Spy", "Mi", "Da", "Sc"]

    useEffect(() => {
        getList()
    }, [])

    useEffect(() => {
        if (toggleButton === 1){
            setRandomized(shuffled(list))
            
            setActivity(towerNumber === 1 ? one_list[Math.floor(Math.random() * one_list.length)] : towerNumber === 2 ? two_list[Math.floor(Math.random() * two_list.length)] : three_list[Math.floor(Math.random() * three_list.length)])
        }
    }, [toggleButton])

    function shuffled(array) {
        const copy = [...array]; 

        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }

        return copy;
    }

    const getList = async () => {
        try {
            const result = await fetch(`https://thj20r4htl.execute-api.us-east-1.amazonaws.com/prod/tasks?param=${towerNumber}`, 
                {
                    method: "GET",
                    headers: {
                        'content-type': "application/json"
                    }
                }
            )
            const data = await result.json();
            console.log(data)
            setList(data.sort((a,b ) => b.points - a.points))
        } catch (error) {

        }
    }
    const updateScores = async () => {
        let pointsArray = [0, 0, 0, 0, 0, 0, 0, 0]
        
        for (let index = 0; index < 8; index++) {
            pointsArray[index] = list.find(a => a.sort_key === winList[index]).points
        }
        const body = {
            id: `${towerNumber}`,
            items: winList,
            points: pointsArray,
        }
         try {
            const result = await fetch(`https://thj20r4htl.execute-api.us-east-1.amazonaws.com/prod/scores`, 
                {
                    method: "PUT",
                    headers: {
                        'content-type': "application/json"
                    },
                    body: JSON.stringify(body)
                }
            )
         } catch (error) {

         }
         getList();
         setWinList([]);


    }

    
    if (!auth) {
        return (
            <div>
                <input type="text"  onChange={(e) => setPassword(e.target.value)} />
                <button onClick={() => setAuth(password === "tytun")}>submit</button>
            </div>
        )
    }

    return (
        <div>
            <div className="header">
                <button className="nav-button" onClick={() => navigate("/")}>Tasks</button>
                <button className="nav-button" onClick={() => navigate("/shop")}>Shop</button>
                <button className="nav-button" onClick={() => navigate("/X")}>X</button>
            </div>
            <div className="tower-container">
                <div className={`standings${towerNumber}`}>
                    <table className={`table${towerNumber}`}>
                        {list.map((item) => (
                            <tr className={`row${towerNumber}`} key={item.sort_key}>
                                <td className={`data${towerNumber}`}>{item.sort_key}</td>
                                <td className={`data${towerNumber}`}>{item.points}</td>
                            </tr>
                        ))}
                    </table>
                </div>
                <div className={`comps${towerNumber}`}>
                    <div className={`toggles${towerNumber}`}>
                        <button className={`toggle-buttons${towerNumber}-${toggleButton === 1 ? "active" : ""}`} onClick={() => setToggleButton(1)}>1</button>
                        <button className={`toggle-buttons${towerNumber}-${toggleButton === 2 ? "active" : ""}`} onClick={() => setToggleButton(2)}>2</button>
                    </div>
                    {toggleButton === 1 && 
                    <div> 
                        <h1 className={`thing${towerNumber}-active`}>{activity}</h1>
                    <div className={`comp${towerNumber}`}>
                       
                        {randomized.length === 16 && randomized.map((item, index) => (
                            index < 8 && 
                            <div className={`thing-container${towerNumber}`}>
                                <h1 className={`thing${towerNumber}-${winList.includes(item.sort_key) ? "active" : "inactive"}`} onClick={() => {
                                    setWinList(prev => Array.from( new Set (
                                        [
                                        ...prev.filter(a => a !== randomized[15 - index].sort_key),
                                        item.sort_key
                                        ]
                                    ))); console.log("win", winList)
                                    }}>{item.sort_key}</h1>
                                <h1 className={`thing${towerNumber}-${winList.includes(randomized[15 - index].sort_key) ? "active" : "inactive"}`} onClick={() => {
                                    setWinList(prev => Array.from( new Set(
                                        [
                                        ...prev.filter(a => a !== item.sort_key),
                                        randomized[15 - index].sort_key
                                        ]
                                    ))); console.log("win", winList)
                                    }}>{randomized[15 - index].sort_key}</h1>
                                
                            </div>
                        ))}
                        <button className={`submit-button${towerNumber}`} onClick={() => updateScores()}>Save</button>
                        
                        
                            
                        
                    </div>
                    </div>}
                </div>
                
            </div>
        </div>
    )
}
export default Tower;